import creditEngineRepository, {CreditEngineRepository} from "@/repositories/creditengine/CreditEngineRepository";

const resource = "/masters";
export default {
  getMasterValues(masterDataRequestDto) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.post(
        `${resource}/values`,
        masterDataRequestDto
    );
  }
}